(function () {
  'use strict';

  /* ── Selectors ─────────────────────────────────────────────── */
  var SELECTORS = {
    openBtn: '[data-compare-open]',
    closeBtn: '[data-compare-close]',
    modal: '[data-compare-modal]',
    swatch: '[data-compare-swatch]',
    swatchToggle: '[data-swatches-toggle]',
    swatchesWrap: '[data-compare-swatches]',
    focusable:
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
  };

  var CLASSES = {
    active: 'is-active',
    expanded: 'is-expanded',
    swatchActive: 'active',
    noScroll: 'compare-products--no-scroll',
  };

  /* ── Constants ─────────────────────────────────────────────── */
  var DESKTOP_LIMIT = 5;
  var MOBILE_LIMIT = 3;
  var DESKTOP_BREAKPOINT = 768;

  /* ── State ─────────────────────────────────────────────────── */
  var activeModal = null;
  var previousFocus = null;

  /* ── Helpers ───────────────────────────────────────────────── */

  function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(SELECTORS.focusable));
  }

  function getSwatchLimit() {
    return window.innerWidth >= DESKTOP_BREAKPOINT ? DESKTOP_LIMIT : MOBILE_LIMIT;
  }

  /* ── Swatch +more toggle initialisation ────────────────────── */

  function initSwatchToggles() {
    var wrappers = document.querySelectorAll(SELECTORS.swatchesWrap);
    for (var i = 0; i < wrappers.length; i++) {
      updateToggleForWrapper(wrappers[i]);
    }
  }

  function updateToggleForWrapper(wrapper) {
    var total = parseInt(wrapper.getAttribute('data-total-swatches'), 10) || 0;
    var limit = getSwatchLimit();
    var blockId = wrapper.getAttribute('data-compare-swatches');
    var toggleBtn = wrapper.querySelector('[data-swatches-toggle="' + blockId + '"]');
    var toggleText = wrapper.querySelector('[data-toggle-text="' + blockId + '"]');

    if (!toggleBtn || !toggleText) return;

    if (total > limit) {
      var remaining = total - limit;
      toggleBtn.removeAttribute('hidden');
      var isExpanded = wrapper.classList.contains(CLASSES.expanded);

      if (isExpanded) {
        toggleText.textContent = 'View less';
        toggleBtn.setAttribute('aria-expanded', 'true');
      } else {
        toggleText.textContent = '+' + remaining + ' more';
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    } else {
      toggleBtn.setAttribute('hidden', '');
    }
  }

  /* ── Modal ─────────────────────────────────────────────────── */

  function openModal(sectionId) {
    var modal = document.querySelector(
      '[data-compare-modal="' + sectionId + '"]'
    );
    if (!modal || activeModal) return;

    previousFocus = document.activeElement;
    activeModal = modal;

    /* Move the modal to <body> so it sits above the sticky header's
       stacking context and is not clipped by any parent overflow. */
    if (modal.parentElement !== document.body) {
      modal._originalParent = modal.parentElement;
      modal._originalNext = modal.nextElementSibling;
      document.body.appendChild(modal);
    }

    modal.removeAttribute('hidden');
    void modal.offsetHeight;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add(CLASSES.active);
    document.body.classList.add(CLASSES.noScroll);

    var firstFocusable = getFocusableElements(modal)[0];
    if (firstFocusable) {
      firstFocusable.focus({ preventScroll: true });
    }
  }

  function closeModal() {
    if (!activeModal) return;

    var modal = activeModal;
    modal.classList.remove(CLASSES.active);
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(CLASSES.noScroll);

    var onEnd = function () {
      modal.setAttribute('hidden', '');
      modal.removeEventListener('transitionend', onEnd);

      /* Move modal back to its original position in the DOM */
      if (modal._originalParent) {
        if (modal._originalNext) {
          modal._originalParent.insertBefore(modal, modal._originalNext);
        } else {
          modal._originalParent.appendChild(modal);
        }
        delete modal._originalParent;
        delete modal._originalNext;
      }
    };
    modal.addEventListener('transitionend', onEnd);

    setTimeout(function () {
      if (!modal.hasAttribute('hidden')) {
        modal.setAttribute('hidden', '');
      }
      /* Fallback: move back if transitionend didn't fire */
      if (modal._originalParent) {
        if (modal._originalNext) {
          modal._originalParent.insertBefore(modal, modal._originalNext);
        } else {
          modal._originalParent.appendChild(modal);
        }
        delete modal._originalParent;
        delete modal._originalNext;
      }
    }, 350);

    activeModal = null;

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }
    previousFocus = null;
  }

  /* ── Focus trap ────────────────────────────────────────────── */

  function trapFocus(e) {
    if (!activeModal || e.key !== 'Tab') return;

    var focusable = getFocusableElements(activeModal);
    if (focusable.length === 0) {
      e.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  /* ── Swatch interaction ────────────────────────────────────── */

  function handleSwatchClick(swatchBtn) {
    var blockId = swatchBtn.getAttribute('data-compare-swatch');
    if (!blockId) return;

    // Toggle active class on sibling swatches
    var parent = swatchBtn.closest('.compare-table__swatches');
    if (parent) {
      var siblings = parent.querySelectorAll('[data-compare-swatch]');
      for (var i = 0; i < siblings.length; i++) {
        siblings[i].classList.remove(CLASSES.swatchActive);
      }
    }
    swatchBtn.classList.add(CLASSES.swatchActive);

    // Read swatch data
    var newImage = swatchBtn.getAttribute('data-swatch-image');
    var newTitle = swatchBtn.getAttribute('data-swatch-title');
    var newColor = swatchBtn.getAttribute('data-swatch-color');
    var newUrl = swatchBtn.getAttribute('data-swatch-url');
    var newPrice = swatchBtn.getAttribute('data-swatch-price');

    // Update product image
    var imgEl = document.querySelector('[data-compare-image="' + blockId + '"]');
    if (imgEl && newImage) {
      imgEl.src = newImage;
      imgEl.alt = newTitle + ' - ' + newColor;
    }

    // Update product name
    var nameEl = document.querySelector('[data-compare-name="' + blockId + '"]');
    if (nameEl && newTitle) {
      nameEl.textContent = newTitle;
    }

    // Update variant name (colour)
    var variantEl = document.querySelector('[data-compare-variant="' + blockId + '"]');
    if (variantEl && newColor) {
      variantEl.textContent = newColor;
    }

    // Update price cell
    var priceCell = document.querySelector('[data-compare-price-cell="' + blockId + '"]');
    if (priceCell && newPrice) {
      priceCell.innerHTML = '<div class="compare-table__price"><span class="compare-table__price-current">' + newPrice + '</span></div>';
    }

    // Update CTA link and text
    var ctaEl = document.querySelector('[data-compare-cta="' + blockId + '"]');
    if (ctaEl && newUrl) {
      ctaEl.href = newUrl;
    }
    var ctaTextEl = document.querySelector('[data-compare-cta-text="' + blockId + '"]');
    if (ctaTextEl && newTitle) {
      ctaTextEl.textContent = 'View ' + newTitle;
    }
  }

  /* ── Swatch toggle (+more / −) ─────────────────────────────── */

  function handleSwatchToggle(toggleBtn) {
    var blockId = toggleBtn.getAttribute('data-swatches-toggle');
    if (!blockId) return;

    var wrapper = toggleBtn.closest('[data-compare-swatches="' + blockId + '"]');
    if (!wrapper) return;

    var isExpanded = wrapper.classList.contains(CLASSES.expanded);

    if (isExpanded) {
      // Collapse
      wrapper.classList.remove(CLASSES.expanded);
    } else {
      // Expand
      wrapper.classList.add(CLASSES.expanded);
    }

    updateToggleForWrapper(wrapper);
  }

  /* ── Keyboard navigation for scrollable table ──────────────── */

  function handleTableKeyboard(e) {
    var scrollContainer = e.target.closest('.compare-table');
    if (!scrollContainer) return;

    var scrollAmount = 200;

    if (e.key === 'ArrowRight') {
      scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else if (e.key === 'ArrowLeft') {
      scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  }

  /* ── Event delegation (single listener on document) ────────── */

  function handleClick(e) {
    // Swatch toggle (+more / −)
    var toggleBtn = e.target.closest(SELECTORS.swatchToggle);
    if (toggleBtn && toggleBtn.closest('.compare-table')) {
      e.preventDefault();
      handleSwatchToggle(toggleBtn);
      return;
    }

    // Swatch click
    var swatchBtn = e.target.closest(SELECTORS.swatch);
    if (swatchBtn && swatchBtn.closest('.compare-table')) {
      e.preventDefault();
      handleSwatchClick(swatchBtn);
      return;
    }

    // Open button
    var openBtn = e.target.closest(SELECTORS.openBtn);
    if (openBtn) {
      e.preventDefault();
      var sectionId = openBtn.getAttribute('data-compare-open');
      openModal(sectionId);
      return;
    }

    // Close button or overlay
    var closeBtn = e.target.closest(SELECTORS.closeBtn);
    if (closeBtn) {
      e.preventDefault();
      closeModal();
      return;
    }
  }

  function handleKeydown(e) {
    if (e.key === 'Escape' && activeModal) {
      e.preventDefault();
      closeModal();
      return;
    }

    trapFocus(e);
    handleTableKeyboard(e);
  }

  /* ── Resize handler — update +more counts ──────────────────── */

  var resizeTimer;
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var wrappers = document.querySelectorAll(SELECTORS.swatchesWrap);
      for (var i = 0; i < wrappers.length; i++) {
        // If collapsed, remove expanded class so CSS re-hides correctly
        if (!wrappers[i].classList.contains(CLASSES.expanded)) {
          updateToggleForWrapper(wrappers[i]);
        }
      }
    }, 150);
  }

  /* ── Init ───────────────────────────────────────────────────── */

  function init() {
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
    window.addEventListener('resize', handleResize);
    initSwatchToggles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
